
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { OrderDeliveryStatusHistory, OrderStatusHistory } from '@/interfaces'

  @Component
  export default class StatusHistory extends Vue {
    @Prop() readonly statuses!: OrderStatusHistory[] | OrderDeliveryStatusHistory[]
    @Prop() readonly header!: string;
  }
